export default __webpack_public_path__ + "static/media/user-secret-solid.48ad9b4c.svg";